export function formatSecondsToMinutesFromChangeData(
  value?: string | null
): string {
  return value && Number(value) > 0
    ? `${String(Number(value) / 60)} mins`
    : 'None';
}
